export default __webpack_public_path__ + "static/media/oracle--white.f7473540.svg";